import React from "react";
import { useTranslation } from "react-i18next";
import "../../styles/ReportDashboard.css";
import { profileTypeLabels } from "../../utils/categoryLabels";

const ReportHeader = ({ company, profile, user, date, reportId, profileId, profileType, userId, targetName, overlapPolicy }) => {
  const { t } = useTranslation("reports_recs", { keyPrefix: "reports_common" });
  const resolvedTargetName =
    typeof targetName === "string" ? targetName : targetName == null ? "" : String(targetName);
  const showTargetName = resolvedTargetName.trim() !== "";
  const displayOrNA = (v) => (!v || v === "N/A" ? t("na") : v);

  const overlapPolicyLabels = {
    aggregate: t("overlapPolicyAggregate"),
    keep_only_latest: t("overlapPolicyLatest"),
    keep_only_oldest: t("overlapPolicyOldest"),
    keep_only_high_severity: t("overlapPolicyHighSeverityOnly"),
    keep_only_failed_tests: t("overlapPolicyAllFailedTestsOnly"),
  };

  return (
    <>
      <div className="report-header">
        <div className="report-summary-card">
          <p className="label">{t("company")}</p>
          <p className="value">{company}</p>
        </div>
        {profile ? (
          <div className="report-summary-card">
            <p className="label">{t("profile")}</p>
            <p className="value">{profile}</p>
          </div>
        ) : null}
        <div className="report-summary-card">
          <p className="label">{t("user")}</p>
          <p className="value">{displayOrNA(user)}</p>
        </div>
        <div className="report-summary-card">
          <p className="label">{t("generatedAt")}</p>
          <p className="value">{date}</p>
        </div>
      </div>
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '12px',
        fontSize: '12px',
        color: '#888',
        fontStyle: 'italic',
        gap: '8px',
        flexWrap: 'wrap'
      }}>
        <span>{t("reportId")}: <strong>{displayOrNA(reportId)}</strong></span>
        {profileId && profileId !== "N/A" && (
          <>
            <span>•</span>
            <span>{t("profileId")}: <strong>{profileId}</strong></span>
          </>
        )}
        <span>•</span>
        <span>{t("profileType")}: <strong>{displayOrNA(profileTypeLabels[profileType] || profileType)}</strong></span>
        <span>•</span>
        <span>{t("userId")}: <strong>{displayOrNA(userId)}</strong></span>
        {overlapPolicy ? (
          <>
            <span>•</span>
            <span>{t("overlapPolicy")}: <strong>{overlapPolicyLabels[overlapPolicy] || overlapPolicy}</strong></span>
          </>
        ) : null}
      </div>
      {showTargetName && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "8px",
            fontSize: "12px",
            color: "#888",
            fontStyle: "italic",
            gap: "8px",
            flexWrap: "wrap",
          }}
        >
          <span>
            {t("target")}: <strong>{resolvedTargetName}</strong>
          </span>
        </div>
      )}
    </>
  );
};

export default ReportHeader;
